import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Car } from 'src/app/domain/car';
import { Driver } from 'src/app/domain/driver';
import { TripRequest } from 'src/app/domain/trip-request';
import { CarService } from 'src/app/service/car/car.service';
import { TripRequestService } from 'src/app/service/trip-request/trip-request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-link-vehicle',
  templateUrl: './link-vehicle.component.html',
  styleUrls: ['./link-vehicle.component.css']
})
export class LinkVehicleComponent implements OnInit {
  solicitationId: number;
  loading: boolean;
  linkForm: FormGroup;
  vehicles: Array<Car> = [];
  data;
  drivers: Array<Driver> = [];

  constructor(
    private service: TripRequestService,
    private serviceCar: CarService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.params.subscribe(params => {
      this.solicitationId = params['id'];
    });
  }

  ngOnInit(): void {
    this.createForm();
    this.getCars();
    this.service.getTripRequest(this.solicitationId).subscribe(data => {
      this.data = data;

      console.log(this.data);

      if (this.data.status != 'waiting') {
        Swal.fire('Atenção!!', 'Só podem Vincular Motoristas de Veículos com Solicitações com Status de Aguardando!!', 'warning');
        this.router.navigate(['process/trip-request']);
      }

      if (this.data.vehicle.id) {
        this.linkForm.controls.vehicle.setValue(this.data.vehicle.id);
        this.linkForm.controls.driver.setValue(this.data.driver.id);
        this.getDriversByCar();
      }



    });
  }

  getCars() {
    this.serviceCar.getCarsActives().subscribe(data => {
      this.vehicles = data;
      console.log(data);

    }, error => {
      Swal.fire('Erro', 'Erro ao carregar Veículos', 'error');
    });
  }

  createForm() {
    this.linkForm = this.fb.group({
      vehicle: ['', Validators.required],
      driver: ['', Validators.required]
    });
  }

  onSelectedVehicle(e) {
    if (this.linkForm.controls.vehicle.value.length) {
      this.loading = true;
      this.getDriversByCar();
    }
  }

  getDriversByCar() {
    this.serviceCar.getDriversByCar(this.linkForm.controls.vehicle.value).subscribe(data => {
      this.drivers = data;
      this.loading = false;
    }, error => {
      this.loading = false;
      Swal.fire('Erro', 'Não foi possível carregar os motoristas deste veículo! Selecione o Veículo novamente.', 'error');
    });
  }

  onSubmit() {

    this.loading = true;

    const value = {
      vehicle: { id: this.linkForm.controls.vehicle.value },
      driver: { id: this.linkForm.controls.driver.value }
    };

    this.service.linkDriver(value, this.solicitationId).subscribe(data => {

      this.loading = false;
      Swal.fire('Sucesso', 'Motorista Adicionado à Solicitação', 'success');
      this.router.navigate(['process/trip-request']);
    }, error => {

      this.loading = false;
      Swal.fire('Erro', 'Erro ao adicionar Motorista à Solicitação', 'error');
    });


  }

}
